import Vue from 'vue';
import VueRouter from 'vue-router';
import { getToken } from '@/lib/token';
import { ADMIN_APP_KEY } from '../globals';
import SignIn from '../views/sso/sign-in.vue';
import Mfa from '../views/sso/mfa.vue';
import ForgotPassword from '../views/sso/forgot-password.vue';
import ResetPassword from '../views/sso/reset-password.vue';
import AdminIndex from '../views/admin/index.vue';
import AppIndex from '../views/admin/app/index.vue';
import GroupIndex from '../views/admin/group/index.vue';
import UserIndex from '../views/admin/user/index.vue';
import AccountCreation from '../views/sso/account-creation.vue';
import AppShow from '../views/admin/app/show.vue';
import RolesUsers from '../views/admin/app/users/index.vue';

Vue.use(VueRouter);

const ADMIN_LOGIN_PATH = `/${ADMIN_APP_KEY}/sign-in`;
const DEFAULT_TITLE = 'Sign in';
const TITLE_PREFIX = 'SeenThis - ';

const routes = [
  {
    path: '/:app/sign-in',
    name: 'sign-in',
    component: SignIn,
    meta: { title: 'Sign in' },
  },
  {
    path: '/:app/2fa',
    name: '2fa',
    component: Mfa,
    meta: { title: '2FA' },
  },
  {
    path: '/:app/forgot-password',
    name: 'forgot-password',
    component: ForgotPassword,
    meta: { title: 'Forgot password' },
  },
  {
    path: '/:app/reset-password/:token',
    name: 'reset-password',
    component: ResetPassword,
    meta: { title: 'Reset password' },
  },
  {
    path: '/:app/account-creation/:id',
    name: 'account-creation',
    component: AccountCreation,
    meta: { title: 'Create account' },
  },
  {
    path: `/${ADMIN_APP_KEY}/sign-in`,
    name: 'admin/sign-in',
    component: SignIn,
    meta: { title: 'Auth admin sign in' },
  },
  {
    path: '/admin',
    name: 'admin/index',
    component: AdminIndex,
    meta: { title: 'Auth admin' },
    children: [
      {
        path: '/admin/apps',
        name: 'admin/apps',
        component: AppIndex,
      },
      {
        path: '/admin/apps/:id',
        name: 'app/show',
        component: AppShow,
      },
      {
        path: '/admin/groups',
        name: 'admin/groups',
        component: GroupIndex,
      },
      {
        path: '/admin/users',
        name: 'admin/users',
        component: UserIndex,
      },
      {
        path: '/admin/apps/:id/:roleId',
        name: 'admin/roles/users',
        component: RolesUsers,
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

const getDocumentTitle = (route) => {
  const title = route.matched.reduce(
    (result, r) => (r.meta && r.meta.title ? r.meta.title : result),
    DEFAULT_TITLE,
  );
  return `${TITLE_PREFIX}${title}`;
};

router.beforeEach((to, from, next) => {
  if (to.path.includes('admin') && !to.path.includes(ADMIN_LOGIN_PATH)) {
    const token = getToken(true);
    if (!token) {
      return next(ADMIN_LOGIN_PATH);
    }
  }

  document.title = getDocumentTitle(to);
  return next();
});

export default router;
